import { GameResource } from "../types";

export const getValueColor = (value: number): string => {
  return value <= 0 ? "text-red-500" : "text-green-400";
};

export const getResourceSprite = (
  resource: GameResource,
): { x: number; y: number } => {
  const sprites: Record<GameResource, { x: number; y: number }> = {
    food: { x: 0, y: 0 },
    fuel: { x: 1, y: 0 },
    fight: { x: 2, y: 0 },
    ore: { x: 4, y: 0 },
    money: { x: 5, y: 0 },
  };
  return sprites[resource];
};
